var _a;
import { generatePromises } from "../generators/generator.promises";
import { GENERATOR_PARAMS } from "./application.constants";
export var getDetail = (_a = generatePromises(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCount = _a.getCount, getInfiniteLoad = _a.getInfiniteLoad, create = _a.create, update = _a.update, archive = _a.archive, unarchive = _a.unarchive;
